export const SHOE_SIZE_UNIT = ["US MEN'S", "US WOMEN'S", "US YOUTH'S"] as const;
export type ShoeSizeUnit = typeof SHOE_SIZE_UNIT[number];

export const SHOE_TYPES = ['standard', 'wide', 'x-wide', 'narrow'] as const;
export type ShoeType = typeof SHOE_TYPES[number];

export function GetShoeSizes(shoeUnit: ShoeSizeUnit) {
	const shoeSizes: number[] = [];
	switch (shoeUnit) {
		case SHOE_SIZE_UNIT[0]:
			for (let i = 3; i <= 16; i += 0.5) {
				shoeSizes.push(i);
			}
			break;
		case SHOE_SIZE_UNIT[1]:
			for (let i = 3; i <= 15; i += 0.5) {
				shoeSizes.push(i);
			}
			break;
		case SHOE_SIZE_UNIT[2]:
			for (let i = 1; i <= 13.5; i += 0.5) {
				shoeSizes.push(i);
			}
			break;
	}

	return shoeSizes;
}
